import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealAttributeDefinitionRequest, DealAttributeDefinitionResponse, NewPageResponse } from '../models/deal-attribute-definition.model';

@Injectable({ providedIn: 'root' })
export class DealAttributeDefinitionApiService {
  private readonly apiUrl = `${environment.apiUrl}api/deal-attribute-definitions`;

  constructor(private http: HttpClient) {}

  getAll(businessId: number, page = 0, size = 20): Observable<NewPageResponse<DealAttributeDefinitionResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId)
      .set('page', page)
      .set('size', size);
    return this.http.get<NewPageResponse<DealAttributeDefinitionResponse>>(this.apiUrl, { params });
  }

  getById(id: number): Observable<DealAttributeDefinitionResponse> {
    return this.http.get<DealAttributeDefinitionResponse>(`${this.apiUrl}/${id}`);
  }

  create(req: DealAttributeDefinitionRequest): Observable<DealAttributeDefinitionResponse> {
    return this.http.post<DealAttributeDefinitionResponse>(this.apiUrl, req);
  }

  update(id: number, req: DealAttributeDefinitionRequest): Observable<DealAttributeDefinitionResponse> {
    return this.http.put<DealAttributeDefinitionResponse>(`${this.apiUrl}/${id}`, req);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
